module.exports = __webpack_public_path__ + "static/img/user-photo.ff442f7.jpg";